import Article from './Article';
import ConfirmModal from './ConfirmModal';
import Footer from './Footer';
import Header from './Header';
import InPageNotification from './InPageNotification';
import InfoModal from './InfoModal';
import JourneyProgress from './JourneyProgress/JourneyProgress';
import Main from './Main';
import MainArticle from './MainArticle';
import NoVillaFound from './NoVillaFound';
import OnHoldNotifications from './OnHoldNotifications';
import OnlyHtmlArticle from './OnlyHtmlArticle';
import PulseArticle from './PulseArticle';
import Statistics from './Statistics';
import SurveyModal from './SurveyModal';
import VendorInfoModal from './VendorInfoModal';
import VendorSearch from './VendorSearch';
import VillaArticleBig from './VillaArticleBig';
import VillaArticleSmall from './VillaArticleSmall';
import VillaDetails from './VillaDetails';
import VillaList from './VillaList';
import VillaListFilters from './VillaListFilters';
import VillaShortDetails from './VillaShortDetails';

export {
  Article,
  MainArticle,
  Header,
  Footer,
  Main,
  OnlyHtmlArticle,
  PulseArticle,
  VendorSearch,
  VillaArticleBig,
  VillaArticleSmall,
  VillaShortDetails,
  Statistics,
  NoVillaFound,
  VillaListFilters,
  VillaDetails,
  VillaList,
  InfoModal,
  ConfirmModal,
  JourneyProgress,
  InPageNotification,
  OnHoldNotifications,
  VendorInfoModal,
  SurveyModal,
};
